module.exports = __webpack_public_path__ + "static/media/student-score-root-bg.86e72381.jpg";